import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import DateSlot from '@components/DataGrid/DateSlot';
import RenderCell from '@components/DataGrid/RenderCell';
import { dateSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

/** Date the consignment's dropped equipment is due to be, or was, picked back up. Sourced from despatch.dsp_delv_pickup_date (see apeqdropos.p). */
const dropDateDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Drop Date',
	minWidth: 130,
	width: 150,
	headerName: 'Drop Date',
	renderHeader: () => <RenderHeader primaryText='Drop Date' />,
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				<DateSlot
					toDate={row.dropDate}
					fullDate
					dateOnly
				/>
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { dropDate } = row;
				return caseInsensitiveIncludes(value, dropDate);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.dropDate?.date ?? '',
	sortable: true,
	sortComparator: dateSortComparator
};

export default dropDateDefinition;
